export enum ComponentTarget {
  Map = 1,
  Table = 2,
  SingleView = 4,
  SingleCreator = 8,
  Popup = 16
}
